import * as React from 'react';
import Tabs from '@mui/material/Tabs';
import Tab from '@mui/material/Tab';
import { ApartmentRounded, AttachMoneyRounded, ArrowDropDownCircleOutlined, MapOutlined, Info } from '@mui/icons-material';
import SchoolIcon from '@mui/icons-material/School';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';



function TabPanel(props) {
    const { children, value, index, ...other } = props;

    return (
        <div
            role="tabpanel"
            hidden={value !== index}
            id={`vertical-tabpanel-${index}`}
            aria-labelledby={`vertical-tab-${index}`}
            {...other}
        >
            {value === index && (
                <Box sx={{ p: 3 }}>
                    <Typography>{children}</Typography>
                </Box>
            )}
        </div>
    );
}

function a11yProps(index) {
    return {
        id: `vertical-tab-${index}`,
        'aria-controls': `vertical-ta   bpanel-${index}`,
    };
}


export default function StudentProfileTab(props) {
    const [value, setValue] = React.useState(0);
    console.log(props.student)
    const handleChange = (event, newValue) => {
        setValue(newValue);
    };

    return (
        <Box>
            <Tabs value={value} onChange={handleChange} aria-label="icon label tabs example" style={{ maxHeight: '100vh', display: "flex", justifyContent: "center", alignItems: "center",  }} sx={{
          justifyContent: "center",
        }}>
                <Tab sx={{
          justifyContent: "center",
        }} icon={<Info />} label="About" {...a11yProps(0)} />
                <Tab sx={{
          justifyContent: "center",
        }} icon={<ArrowDropDownCircleOutlined />} label="Dropout Prediction" {...a11yProps(1)} />
            </Tabs>

            <TabPanel value={value} index={0}  sx={{
          justifyContent: "center",
        }}
>
            <Box sx={{ p: 3 }}>
          <Typography variant="h6" mb={2}>
            Student Information
          </Typography>
          <Typography variant="subtitle1" mb={1}>
            Name: {props.student.name}
          </Typography>
          <Typography variant="subtitle1" mb={1}>
            Email: {props.student.email}
          </Typography>
          <Typography variant="subtitle1" mb={1}>
            DOB: {props.student.dob}
          </Typography>
          <Typography variant="subtitle1" mb={1}>
            Faimly Income: {props.student.familyIncome}
          </Typography>

          <Typography variant="subtitle1" mb={1}>
          Gender: {props.student.gender}
          </Typography>


          <Typography variant="subtitle1" mb={1}>
            Disablity: {props.student.disability}
          </Typography>
          <Typography variant="subtitle1" mb={1}>
          Distance form school: {props.student.distanceFromSchool}
          </Typography>
          <Typography variant="subtitle1" mb={1}>
          No of siblings: {props.student.noOfSiblings}
          </Typography>

          
        </Box>
      </TabPanel>

      <TabPanel value={value} index={1}     sx={{
          justifyContent: "center",
        }}
>
        This student has potential of dropping out from the school 
      </TabPanel>
            
            
        </Box>


    );
}
